package com.patronat.top.ui.organisms


import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.theme.ExtraDescriptionLarge
import com.patronat.top.ui.theme.ExtraTitleLarge

import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft950

@Composable
fun EmptyStateContent(
    image: Painter,
    title: String,
    description: String,
    buttonText: String,
    onButtonClick: () -> Unit,
    modifier: Modifier = Modifier,
    buttonIcon: Painter? = null,
    buttonNeeded: Boolean = false,
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .padding(24.dp)
    ) {

        if (buttonNeeded) {
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.TopEnd
            ) {
                AppButton(
                    text = buttonText,
                    onClick = onButtonClick,
                    type = ButtonType.BrownFilled,
                    leadingIcon = buttonIcon
                )
            }
        }


       // Spacer(modifier = Modifier.weight(1f))


        Column(
            modifier = Modifier.fillMaxWidth().fillMaxHeight(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Image(
                painter = image,
                contentDescription = null,
                modifier = Modifier
                    .width(513.dp)
                    .height(342.dp)
                    .aspectRatio(1.5f)
            )

            Spacer(modifier = Modifier.height(32.dp))


            Text(
                text = title,
                style = ExtraTitleLarge,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(12.dp))


            Text(
                text = description,
                style = ExtraDescriptionLarge,
                textAlign = TextAlign.Center
            )
        }


      //  Spacer(modifier = Modifier.weight(1f))
    }
}